import { useState } from "react";
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog";
import { storeBulk } from "../services/api";
import { useMutation } from "react-query";
import { useDropzone } from "react-dropzone";
import { CSVLink } from "react-csv";

export default function AddCSV({ open, close, menu, subcategory, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [array, setArray] = useState([]);
  const [fileDataError, setDataFileError] = useState(false);
  const fileReader = new FileReader();
  const csvHeaders = ["name", "price", "description"]

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'text/csv',
    onDrop: acceptedFiles => {
      if (acceptedFiles[0]) {
        fileReader.onload = function (event) {
          const text = event.target.result
          csvFileToArray(text)
        }
        fileReader.readAsText(acceptedFiles[0])
      }
    }
  })

  const mutation = useMutation(storeBulk, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else {
        setArray([])
        setDataFileError(false)
        reportAction(true, 'Acción realizada correctamente', 'success')
      }
    }
  })

  const handleAdd = () => {
    const data = array.map((item) => {
      return {
        name: item.name,
        description: item.description,
        price: parseFloat(item.price, 0),
        active: true
      }
    })
    setIsLoading(true)
    mutation.mutate({ id: subcategory, params: { products: data } })
  }

  const handleClose = () => { setArray([]); setDataFileError(false); close() }

  //check if values in array exist in another array
  const checkArray = (array, check) => {
    return array.every((item) => check.includes(item))
  }

  const csvFileToArray = string => {
    const csvHeaders = string.slice(0, string.indexOf("\n")).replace(/[\r\n]/gm, '').split(",")
    const csvHeader = csvHeaders.map((item) => item.toLowerCase().replace(/[\r\n]/gm, '').replace(/ /g, ""))

    if (checkArray(["name", "description", "price"], csvHeader)) {
      const csvRows = string.slice(string.indexOf("\n") + 1).split("\n")
      const array = csvRows.map(i => {
        const values = i.split(",")
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index]
          return object;
        }, {})
        return obj
      })
      const finalArray = array.filter((item) => item.name !== null && item.name !== undefined && item.name !== "")
      setArray(finalArray)
      setDataFileError(false)
    } else {
      setArray([])
      setDataFileError(true)
    }
  };

  /* const handleAnalizer = (e) => {
    e.preventDefault()
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result
        csvFileToArray(text)
      }
      fileReader.readAsText(file)
    }
  }; */

  const headerKeys = Object.keys(Object.assign({}, ...array))

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" disabled={fileDataError || array.length == 0} onClick={() => handleAdd()}>{t('button_text_add')}</Button>
    </> : <CircularProgress />}
  </>)

  return (
    <FlexibleWidthDialog maxWidth="sm" open={open} title={t('builder_bulkload_dialog_title')} actions={<Actions />}>
      <Typography sx={{ mb: 2, fontWeight: "bold" }}> {t('builder_bulkload_dialog_description_products')} </Typography>
      <Typography sx={{ mb: 2, fontWeight: "bold", fontSize: 12 }}>
        <CSVLink data={[csvHeaders]} filename="products_to_upload.csv"> Descarga un ejemplo del archivo que se debe subir dando click aquí</CSVLink>
      </Typography>
      <div {...getRootProps({ className: 'dropzone' })} style={{ border: "1px dashed gray", padding: 10 }}>
        <input {...getInputProps()} />
        <p>Arrastra y suelta tu archivo aquí o da clic para seleccionar el archivo</p>
      </div>
      {/* <div style={{ textAlign: "center", marginTop: 20, marginBottom: 20 }}>
          <Button variant="contained" onClick={(e) => { handleAnalizer(e); }}>Analizar archivo</Button>
        </div> */}
      {fileDataError ?
        <div>
          <Typography component="p" variant="body1" color="error" sx={{ textAlign: "center", marginTop: 4 }}> El archivo no tiene el formato correcto </Typography>
        </div> : null
      }
      {array.length > 0 ?
        <TableContainer component={Paper}>
          <Table sx={{ width: "100%" }} size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {headerKeys.map((key, index) => (<TableCell key={index} sx={{ fontWeight: "bold" }}>{key}</TableCell>))}
              </TableRow>
            </TableHead>
            <TableBody>
              {array.map((item, index) => (
                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  {Object.values(item).map((val) => (<TableCell>{val}</TableCell>))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        : null}
    </FlexibleWidthDialog>
  )
}
//https://refine.dev/blog/how-to-import-csv/#example